module.exports = __webpack_public_path__ + "img/dpd_bicicletas.adb69881.jpg";